/* eslint-disable */
export const isNumber = x => typeof x === 'number';
export const isArray = x => x instanceof Array;
export const isFunction = x => typeof x === 'function';
export const isObject = x => typeof x === 'object' && Object.keys(x).length > 0;
export const isString = x => typeof x === 'string';
export const isUndefined = x => typeof x === 'undefined';
/**
 * Pad a string to a certain length with another string.
 * @param {string|number} str
 * @param {number} len
 * @param {(string|number)=} pad
 */
export const strPad = (str, len, pad) => {
  if (isNumber(str) || isString(str)) {
    // cast to string
    str = String(str);

    // sanitize pad string
    if (isNumber(pad)) { pad = String(pad); } else if (!isString(pad)) { pad = ' '; } else if (!pad.length) { pad = ' '; } else if (pad.length > 1) { pad = pad[0]; }

    // pad string
    while (str.length < len) { str = pad + str; }
  }

  return str;
};

export const assetsUrl = (url) => {
  /* eslint-disable no-useless-escape */
  const pattern = new RegExp('^((http(s)?(:\/\/))|\/\/)');
  url = pattern.test(url) ? url : require(`@/assets/img/${url}`);
  return url;
};

export const cekString = (str) => {
  /* eslint-disable no-useless-escape */
  str = str || '';
  return str;
};
/**
 * Format time.
 * @param {string} start
 * @param {string} end
 * @param {string} zone
 * @return {strings}
 */
export const formatTime = (start, end, zone) => {
  const range = start === end ? 1 : 2;
  const startTime = start.split(':');
  const hourStart = startTime[0];
  const minStart = startTime[1];
  const endTime = end.split(':');
  const hourEnd = endTime[0];
  const minEnd = endTime[1];

  // format time string
  const str = [];
  if ((parseInt(hourEnd) - parseInt(hourStart)) >= 23) {
    str.push('24 jam');
  } else {
    str.push(range === 1 ? (`${hourStart  }:${  minStart  } ${  zone[1]}`)
      : (`${hourStart  }:${  minStart  } - ${  hourEnd  }:${  minEnd  } ${  zone[1]}`));
  }

  return str.join('');
};

/**
 * Find last date number of a month.
 * @param {number} year
 * @param {number} month
 * @return {number}
 */
export const getLastDateOfMonth = (year, month) => (new Date(new Date(year, month, 1) - 1)).getDate();

/**
* Print date duration.
* @param {string|Date} start
* @param {string|Date} end
* @param {Object} options
* @return {string}
*/
export const duration = (start, end, options) => {
  const M_MONTHS = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

  options = options || {};

  // set default options
  let str = '';
  const shortDate = !!options.shortDate;
  const separator = options.separator || '-';

  // format date
  if (typeof start === 'string') {
    start = new Date(start.replace(/-/g, '/'));
  } else if (!(start instanceof Date)) {
    start = new Date(start);
  }

  if (typeof end === 'string') {
    end = new Date(end.replace(/-/g, '/'));
  } else if (!(end instanceof Date)) {
    end = new Date(end);
  }

  if (!!start.getDate() && !!end.getDate()) {
    // same year
    if (start.getYear() === end.getYear()) {
      // same month
      if (start.getMonth() === end.getMonth()) {
        // same date
        if (start.getDate() === end.getDate()) {
          str = [
            start.getDate(),
            shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
            start.getFullYear(),
          ];

          // different date
        } else {
          str = [
            start.getDate(),
            separator,
            end.getDate(),
            shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
            start.getFullYear(),
          ];
        }

        // different month
      } else {
        str = [
          start.getDate(),
          shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
          separator,
          end.getDate(),
          shortDate ? M_MONTHS[end.getMonth()].substr(0, 3) : M_MONTHS[end.getMonth()],
          start.getFullYear(),
        ];
      }

      // different year
    } else {
      str = [
        start.getDate(),
        shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
        start.getFullYear(),
        separator,
        end.getDate(),
        shortDate ? M_MONTHS[end.getMonth()].substr(0, 3) : M_MONTHS[end.getMonth()],
        end.getFullYear(),
      ];
    }

    str = str.join(' ');
  }

  return str;
};

/**
* get value object by desc key
* desc string with .
*/
export const getDeepObj = (obj, desc) => {
  const arr = desc.split('.');
  while (arr.length && (obj = obj[arr.shift()])) {
    if (!arr.length) {
      return obj || {};
    }
  }
};

/**
* convert arr to obj
* desc string with .
*/
export const arrayToObject = array =>
  array.reduce((obj, item) => {
    obj[isArray(item) ? item[0] : item.id || item.key] = item;
    return obj;
  }, {});

export const range = (end, start = 0, step = 1) => {
  const arr = [];
  for (let i = start; i < end; i += step) {
    arr.push(i);
  }
  return arr;
};
/**
* convert date to str
* desc yy-mm-dd
*/
export const localDate = (date) => {
  const M_MONTHS = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
  const temp = date.split('-');
  return [temp[2], M_MONTHS[Number(temp[1]) - 1], temp[0]].join(' ');
};
